import cx from "classnames";
import { CoreLink } from "common/CoreLink";
import { PopoverMenu, PopoverMenuHeading, PopoverMenuItem } from "common/styleguide/PopoverMenu";
import React from "react";
import styles from "./PopoverLinkMenu.scss";

export class PopoverLinkMenu extends React.PureComponent {
  render() {
    const { children, slim, disabled, ...props } = this.props;
    return (
      <PopoverMenu className={cx(styles.PopoverLinkMenu, slim && styles.slim, disabled && styles.disabled)} {...props}>
        {children}
      </PopoverMenu>
    );
  }
}

export const PopoverLinkMenuItem = ({ to, href, className, children, ...props }) => (
  <PopoverMenuItem className={cx(styles.PopoverLinkMenuItem, className)}>
    <CoreLink to={to} href={href} {...props}>
      {children}
    </CoreLink>
  </PopoverMenuItem>
);

export const PopoverLinkMenuHeading = PopoverMenuHeading;

export const PopoverMenuDivider = () => <div className={styles.divider} />;
